(function () {
  function initAkTeam() {
    var modal = document.querySelector('#akTeamModal');
    if (!modal) {
      console.log('[ak-team] modal not found');
      return;
    }

    // Nieuw: avatar bestaat niet meer, dus weg
    var title = modal.querySelector('#akModalTitle');
    var subtitle = modal.querySelector('#akModalSubtitle');
    var content = modal.querySelector('#akModalContent');
    var photoLarge = modal.querySelector('#akModalPhotoLarge');

    if (!title || !subtitle || !content || !photoLarge) {
      console.log('[ak-team] modal parts missing');
      return;
    }

    function openModalFromBtn(btn) {
      var name = btn.getAttribute('data-ak-name') || '';
      var role = btn.getAttribute('data-ak-role') || '';
      var photo = btn.getAttribute('data-ak-photo') || '';
      var bio = btn.getAttribute('data-ak-bio') || '';

      // Titel rechts
      title.textContent = name;
      subtitle.textContent = role;

      // Grote foto links
      if (photo) {
        photoLarge.src = photo;
        photoLarge.alt = name;
        photoLarge.style.display = '';
      } else {
        photoLarge.removeAttribute('src');
        photoLarge.alt = '';
        photoLarge.style.display = 'none';
      }

      // Tekst rechts
      content.innerHTML = bio
  .split('\n\n')
  .map(function (p) {
    return '<p>' + p.replace(/\n/g, '<br>') + '</p>';
  })
  .join('');

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    // voorkom dubbel binden bij hot reloads / section reload
    if (modal._akBound) return;
    modal._akBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button.ak-btn');
      if (btn) {
        e.preventDefault();
        openModalFromBtn(btn);
        return;
      }

      if (e.target && (e.target.hasAttribute('data-ak-close') || e.target.closest('[data-ak-close]'))) {
        e.preventDefault();
        closeModal();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    console.log('[ak-team] init done');
  }

  function boot() {
    try { initAkTeam(); } catch (e) { console.log('[ak-team] error', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
